export const START_GET_HOME_LIST = "START_GET_HOME_LIST";
export const SUCCESS_GET_HOME_LIST = "SUCCESS_GET_HOME_LIST";
export const ERROR_GET_HOME_LIST = "ERROR_GET_HOME_LIST";

//No Of Alert In Dashboard
export const START_GET_NO_OF_ALERT = "START_GET_NO_OF_ALERT";
export const SUCCESS_GET_NO_OF_ALERT = "SUCCESS_GET_NO_OF_ALERT";
export const ERROR_GET_NO_OF_ALERT = "ERROR_GET_NO_OF_ALERT";

export const START_CHASEUP_CHART = "START_CHASEUP_CHART";
export const SUCCESS_CHASEUP_CHART = "SUCCESS_CHASEUP_CHART";
export const ERROR_CHASEUP_CHART = "ERROR_CHASEUP_CHART";

export const START_ORDER_CHART = "START_ORDER_CHART";
export const SUCCESS_ORDER_CHART = "SUCCESS_ORDER_CHART";
export const ERROR_ORDER_CHART = "ERROR_ORDER_CHART";

export const START_PAYMENT_CREATE = "START_PAYMENT_CREATE";
export const SUCCESS_PAYMENT_CREATE = "SUCCESS_PAYMENT_CREATE";
export const ERROR_PAYMENT_CREATE = "ERROR_PAYMENT_CREATE";

export const START_PAYMENT_LINK = "START_PAYMENT_LINK";
export const SUCCESS_PAYMENT_LINK = "SUCCESS_PAYMENT_LINK";
export const ERROR_PAYMENT_LINK = "ERROR_PAYMENT_LINK";

export const START_PAYMENT_LIST = "START_PAYMENT_LIST";
export const SUCCESS_PAYMENT_LIST = "SUCCESS_PAYMENT_LIST";
export const ERROR_PAYMENT_LIST = "ERROR_PAYMENT_LIST";

export const START_SUBSCRIPTION_CREATE = "START_SUBSCRIPTION_CREATE";
export const SUCCESS_SUBSCRIPTION_CREATE = "SUCCESS_SUBSCRIPTION_CREATE";
export const ERROR_SUBSCRIPTION_CREATE = "ERROR_SUBSCRIPTION_CREATE";

export const CLEAR_SUBSCRIPTION_CREATE = "CLEAR_SUBSCRIPTION_CREATE";

export const START_SUBSCRIPTION_CANCEL = "START_SUBSCRIPTION_CANCEL";
export const SUCCESS_SUBSCRIPTION_CANCEL = "SUCCESS_SUBSCRIPTION_CANCEL";
export const ERROR_SUBSCRIPTION_CANCEL = "ERROR_SUBSCRIPTION_CANCEL";

export const START_SUBSCRIPTION_UPDATE = "START_SUBSCRIPTION_UPDATE";
export const SUCCESS_SUBSCRIPTION_UPDATE = "SUCCESS_SUBSCRIPTION_UPDATE";
export const ERROR_SUBSCRIPTION_UPDATE = "ERROR_SUBSCRIPTION_UPDATE";
